import { createContext } from "react";

interface NavContextType {
  title: string;
  setTitle: (newVal: string) => void;
}

export const NavContext = createContext<NavContextType>({
  title: "",
  setTitle: () => {},
});

